import React, { type CSSProperties } from 'react';
import styled, { css } from 'styled-components';
import JustificationContainer from '~/components/atom/JustificationContainer';

export type Props = {
  onClick?: () => void;
  style?: CSSProperties;
};

const BrowserFrame: React.FCC<Props> = ({ dataTestId, children, ...rest }) => (
  <Container data-testid={dataTestId} {...rest}>
    <Header>
      <JustificationContainer align="center" justification="start" gap="xs">
        <MacButton $color="#FF4F49" />
        <MacButton $color="#E3B725" />
        <MacButton $color="#48BA27" />
      </JustificationContainer>
    </Header>
    <ChildContainer>{children}</ChildContainer>
  </Container>
);

/**
 * All "fixed colours" in this file have been snapped from https://browserframe.com/
 */

const Container = styled.div<{}>(
  ({ theme }) => css`
    border-radius: ${theme.getTokens().border.radius.base};
    overflow: hidden;
    box-shadow: ${theme.boxShadow('modal')};
    border: 1px solid #6d6d6d;
  `,
);
const Header = styled.header(
  ({ theme }) => css`
    padding: ${theme.space('m')} ${theme.space('s')};
    border-bottom: 1px solid #6d6d6d;

    background: rgb(41, 41, 41);
    background: linear-gradient(
      0deg,
      rgba(41, 41, 41, 1) 0%,
      rgba(65, 65, 65, 1) 100%
    );
  `,
);
const MacButton = styled.div<{ $color: string }>(
  ({ $color }) => css`
    width: 0.8rem;
    height: 0.8rem;
    border-radius: 50%;
    background-color: ${$color};
  `,
);
const ChildContainer = styled.div(
  ({}) => css`
    background-color: #000;
    position: relative;
    overflow: hidden;
  `,
);

export default BrowserFrame;
